import React, { useEffect, useState } from "react";
import { loadMicroApp } from "qiankun";
import './index.css';

const LoadingPlaceholder = () => {
  const [isLoading, ] = useState(true);

  if (!isLoading) {
    return null;
  }
  return (
    <div className="loading-overlay">
      <span className="loader">
        <span className="loader-inner"></span>
      </span>
      <div className="index-loading-text">Hyper3D</div>
    </div>
  );
}


export default LoadingPlaceholder;